<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <div>
          <router-link :to="'/vehicles/drivers/create/'">
            <b-button variant="success" class="float-right mb-3">Neuer Fahrer</b-button>
          </router-link>
          <b-table responsive bordered striped hover :items="list" :fields="fields">
            <template v-slot:cell(dayofbirth)="data">
                {{ data.item.dayofbirth | formatDate }}
            </template>
            <template v-slot:cell(address)="data">
              <div v-if="data.item.address !== null && data.item.address.address_line_1 !== null" class="scrollable">
                {{ data.item.address.address_line_1 }} <br>
                {{ data.item.address.address_line_2 }}
              </div>
              <div v-else-if="data.item.address !== null" class="scrollable">
                {{ data.item.address.address_line_2 }}
              </div>
            </template>
            <template v-slot:cell(actions)="data">
              <div class="text-center">
                <router-link :to="'/vehicles/drivers/edit/' + data.item.id">
                  <b-button type="primary" size="small" icon="fa-icon-edit">
                    Ändern
                  </b-button>
                </router-link>
                <!--<router-link :to="'/vehicles/drivers/delete/' + data.item.id">
                  <b-button class="ml-1" type="primary" variant="danger" size="small" icon="fa-icon-edit">
                    Entfernen
                  </b-button>
                </router-link>-->
              </div>
            </template>
          </b-table>

        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
    import Resource from '@/api/resource';

    const driverResource = new Resource('drivers');
    export default {
        name: "ListDrivers",
        data() {
            return {
                fields: [
                    {
                        key: 'firstname',
                        label: 'Vorname',
                        sortable: true,
                        thStyle: {
                            align: 'center',
                        }
                    },
                    {
                        key: 'lastname',
                        label: 'Nachname',
                        sortable: true,
                        thStyle: {
                            align: 'center',
                        }
                    },
                    {
                        key: 'dayofbirth',
                        label: 'Geburtsdatum',
                        sortable: true,
                        thStyle: {
                            align: 'center',
                        }
                    },
                    {
                        key: 'address',
                        label: 'Addresse',
                        sortable: false,
                        thStyle: {
                            align: 'center',
                        }
                    },
                    {
                        key: 'address.postcode',
                        label: 'PLZ',
                        sortable: true,
                        thStyle: {
                            align: 'center',
                        }
                    },
                    {
                        key: 'address.city',
                        label: 'Ort',
                        sortable: true,
                        thStyle: {
                            align: 'center',
                        }
                    },
                    {
                        key: 'actions',
                        label: 'Aktionen',
                        sortable: false,
                        thStyle: {
                            //width: '200px'
                        }
                    }
                ],
                list: null,
                total: 0,
                listLoading: true,
                listQuery: {
                    page: 1,
                    limit: 15,
                },
            }
        },
        created() {
            this.getList();
        },
        methods: {
            async getList() {
                this.listLoading = true;
                const {data} = await driverResource.list(this.listQuery);
                this.list = data;
                this.total = data.length;
                this.listLoading = false;
            }
        }
    }
</script>

<style scoped>

</style>
